<template>
<div class="camera-management-d">
	<div class="left">
		<editForm ref="editFormIP" :formConfig="ipformConfig" :ruleForm="info" :rules="ipRules" :buttonConfig="ipbuttonConfig"></editForm>
		<div class="label">
			<span class="label-title">同步圈子</span>
			<el-checkbox-group v-model="info.serverType" size="medium">
				<el-checkbox-button v-for="item in tagList" :label="item.itemValue" :key="item.id">{{item.itemName}}</el-checkbox-button>
			</el-checkbox-group>
			<div class="warn" v-if="showWarnInfo">请选择要同步的圈子</div>
		</div>
	</div>
	<div class="right">
		<editForm ref="editFormIP2" :formConfig="ipformConfig2" :ruleForm="info"></editForm>
	</div>
</div>
</template>

<script>
	import publicApi from '../../../../api-path/public-api.js'
	import {mediaApi} from '../../../../api-path/media-api.js'
export default {
    name: "allUsers",
	props:['info','disabled'],
    data() {
        return {
			publicApi,
			tagList:[],
			showWarnInfo:false,
            ipRules: {
                title: [{
                    required: true,
                    trigger: 'change',
                    message: '请输入标题'
                }],
                author: [{
                    required: true,
                    trigger: 'change',
                    message: '请输入作者',
                }],
                areaName: [{
                    required: true,
                    trigger: 'change',
                    message: '请选择区域',
                }],
            },
            ipbuttonConfig: {
                buttons: [{
                        type: 'save', // 保存
                        loading: false,
						title:'发布',
						btnType:'success',
						disabled:this.disabled,
                        fn: (data) => {
							let newData=JSON.parse(JSON.stringify(data));
							if(newData.serverType.length!=0){
								this.showWarnInfo=false;
								let imgs=newData.imgList.map(item=>{
									return item.url
								});
								let videos=newData.videoList.map(item=>{
									return item.url
								});
								let serverType=newData.serverType;
								newData.coverImg=imgs.toString();
								newData.playUrl=videos.toString();
								newData.serverType=serverType.toString();
								newData.publishTime=new Date(newData.publishTime+1000).Format('yyyy-MM-dd hh:mm:ss')
								newData.false=true;
								this.$http.post(mediaApi.groupConSave,newData).then(res=>{
									if(res.status==200){
										this.$message.success('保存成功！')
										this.$emit('closeAddPage',false)
									}
								})
							}else{
								this.showWarnInfo=true;
								this.$message.error('请填完所有必填项')
							}
                        },
                    },{
                        type: 'save', // 保存
                        loading: false,
						title:'保存为草稿',
						disabled:this.disabled,
                        fn: (data) => {
							let newData=JSON.parse(JSON.stringify(data));
							let imgs=newData.imgList.map(item=>{
								return item.url
							});
							let videos=newData.videoList.map(item=>{
								return item.url
							});
							let serverType=newData.serverType;
							newData.coverImg=imgs.toString();
							newData.playUrl=videos.toString();
							newData.serverType=serverType.toString();
							newData.publishTime=new Date(newData.publishTime+1000).Format('yyyy-MM-dd hh:mm:ss');
							newData.draft=true;
							this.$http.post(mediaApi.groupConSave,newData).then(res=>{
								if(res.status==200){
									this.$message.success('保存成功！')
									this.$emit('closeAddPage',false)
								}
							})
                        },
                    },
                ]
            },
			ipformConfig2:{
				disabled: false,
				ref: 'editFormIP2',
				items:[
					[{
						valueType: 'input', // 类型
						label: '内容概要',
						key: 'content', // 数据名称
						prop: 'content', // 验证规则
						labelWidth: "100px", // label 宽度
						itemWidth: '50%',
						maxlength:50,
						disabled:this.disabled,
						placeholder: '一句话概述当前内容', // 提示信息
					}],
					[
					  {
					    valueType: 'ueditor', // 类型
					    itemWidth: '80%',
						disabled:this.disabled,
					    prop: 'major',
					    label: '内容详情',
					    inputWidth: '100%',
					    labelWidth: "100px",
					    key: 'major',
					  }
					],
				]
			},
            ipformConfig: {
                disabled: false,
                ref: 'editFormIP',
                items: [
                    [{
                        valueType: 'input', // 类型
                        label: '标题',
                        key: 'title', // 数据名称
                        prop: 'title', // 验证规则
                        labelWidth: "100px", // label 宽度
                        maxlength: '50',
                        itemWidth: '50%',
						disabled:this.disabled,
                        placeholder: '请输入标题', // 提示信息
                    }], [{
                        valueType: 'input', // 类型
                        label: '作者',
                        key: 'author', // 数据名称
                        prop: 'author', // 验证规则
                        labelWidth: "100px", // label 宽度
                        itemWidth: '50%',
						disabled:this.disabled,
                        placeholder: '请输入作者名称', // 提示信息
                    }],
                    [{
                        valueType: 'input', // 类型
                        label: '发布单位',
                        key: 'unit', // 数据名称
                        prop: 'unit', // 验证规则
                        labelWidth: "100px", // label 宽度
                        itemWidth: '50%',
						disabled:this.disabled,
                        placeholder: '请输入发布单位', // 提示信息
                    }],
					[{
                        valueType: 'tree-selected', // 类型
                        label: '选择区域',
                        key: 'areaName', // 数据名称
                        prop: 'areaName', // 验证规则
                        labelWidth: "100px", // label 宽度
                        itemWidth: '50%',
                        maxlength: 50,
                        disabled: false,
						disabled:this.disabled,
                        placeholder: '请选择发布区域', // 提示信息
                        fn: (data) => { //选择的值
                            this.info.areaName = data.name;
                            this.info.areaId = data.id;
                        }
                    }],[{
						valueType: 'datetime', // 类型
						label: '发布时间',
						key: 'publishTime', // 数据名称
						prop: 'publishTime', // 验证规则
						labelWidth: "100px", // label 宽度
						itemWidth: '50%',
						disabled:this.disabled,
						placeholder: '请选择发布时间', // 提示信息
					}],
					[{
						// valueType: 'singleUpload', // 类型
						valueType: 'upload', // 类型
						label: '上传封面',
						key: 'imgList', // 数据名称
						prop: 'imgList',
						labelWidth: "100px", // label 宽度
						itemWidth: '100%',
						disabled:this.disabled,
						otherConfig: {
							showInfoInput: false,
							// infoInputPlaceholder: '请输入图片文字说明',
							imgWidth: '100px',
							imgHeight: '80px',
							uploadHint: '注：支持jpg、png、tif、gif等格式且不超过20M，最多传3张',
							method: ['delete', 'edit']
						},
						uploadConfig: {
							accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif',
							uploadPath: publicApi.uploadFile,
							size: '20480kb',
							count: 3,
						},
						options: {
							fileUrlKey: 'url',
							fileInfoKey: 'description',
						},
					}],[{
						// valueType: 'singleUpload', // 类型
						valueType: 'upload', // 类型
						label: '音/视频',
						key: 'videoList', // 数据名称
						prop: 'videoList',
						labelWidth: "100px", // label 宽度
						itemWidth: '100%',
						disabled:this.disabled,
						otherConfig: {
							showInfoInput: false,
							// infoInputPlaceholder: '请输入图片文字说明',
							imgWidth: '100px',
							imgHeight: '80px',
							uploadHint: '注：建议视频不超过200M',
							method: ['delete', 'edit']
						},
						uploadConfig: {
							accept: '.mp4,.3gp,audio/mp3, audio/wav,audio/m4a',
							uploadPath: publicApi.uploadFile,
							size: '20480kb',
							count: 1,
						},options: {
							fileUrlKey: 'url',
							fileInfoKey: 'description',
                        },
					}]
                ],

            },
		}
    },
    created() {
		console.log(this.info);
		this.tagList=JSON.parse(localStorage.getItem('codeData'))['GROUP_CONTROLLER'];
    },
    mounted() {
        // this.setSearchParams();
    },
    methods: {
    }

}
</script>

<style lang="less">
.camera-management-d {
	margin-left: 10px;
	box-sizing: border-box;
	padding: 10px;
	background: #fff;
	display: flex;
	flex: 1;
	position: relative;
	.left{
		flex: 1;
		margin-right: 10px;
		.warn{
			color: #F56C6C;
			font-size: 12px;
			line-height: 1;
			padding-top: 4px;
			margin-left: 100px;
			margin-top: 10px;
		}
	}
	.right{
		flex: 1;
	}
	.label-title{
		text-align: right;
		vertical-align: middle;
		float: left;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		box-sizing: border-box;
			&::before{
				content: '*';
				color: #F56C6C;
				margin-right: 4px;
			}
		}
	.edit-form-btn{
		position: absolute;
		bottom: 0;
		height: 60px;
		display: flex;
		width: 100%;
		left: 0;
		border-top: 10px solid #f1f4fb;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
		margin-left: 0 !important;
	}
}
</style>
